import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular-ivy';
import { environment } from '../environments/environment';

const sentryConfig = environment.services.sentry;

if (environment.production) {
  Sentry.init(
    {
      ...sentryConfig,
      // To set your release and dist versions
      release: `stormcloudapp@${environment.version}`,
      // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
      // We recommend adjusting this value in production.
      tracesSampleRate: 1.0,
      integrations: [
        new SentryAngular.BrowserTracing({
          // Set "tracePropagationTargets" to control for which URLs distributed tracing should be enabled
          tracePropagationTargets: ['localhost', 'stormcloudapp'],
          routingInstrumentation: SentryAngular.routingInstrumentation,
        }),
      ],
      environment: environment.name,
    },
    // Forward the init method to the sibling Framework.
    SentryAngular.init,
  );
}
